// ----------------------------------------------------------------------
// Dato CMS Translation Plugin
//
// OPO Translation Service file. Defines the translation request types
//
// NOTE: https://www.deepl.com/fr/docs-api/translating-text/request/
// ----------------------------------------------------------------------
// translationService.ts
// Oeil Pour Oeil - 2025

import { IIndexable } from "./itemAccessorTypes";

// --- Model ---

/// Format used to receive translations from OPO Translation Service
export type OPOTranslateResponse = {
  translations: Array<{
    text: string;
  }>;
};

/// Credentials for cross-origin ressource sharing ( CORS, X-API-KEY )
export type OPOTranslateCredentials = { apiUrl: string; apiKey: string };

/// Translation Request function signature
/// Takes an array of strings in input, and asynchronously returns respective translations
export type TranslationRequest = (
  content: Array<string>,
) => Promise<Array<string>>;

/// Translation Request builder signature
export type TranslationRequestBuilder = (
  from: string,
  to: string,
  useChatGPT: boolean,
  batchTranslations: boolean,
  translateAnswers: boolean,
) => TranslationRequest;

/// Translation Service builder signature
export type MakeTranslationRequestBuilder = (
  credentials: OPOTranslateCredentials,
) => TranslationRequestBuilder;

/// Translation Service Factory

const makeTranslationRequestBuilder: MakeTranslationRequestBuilder = ({
  apiUrl,
  apiKey,
}) => {
  // Returns a TranslationRequestBuilder, which returns an asynchronous TranslationRequest
  return (from, to, useChatGPT, batchTranslations, translateAnswers) => async (content) => {
    var service: string = "DeepL";
    if (useChatGPT) {
      service = "ChatGPT";
    }

    // build
    const body = JSON.stringify({
      texts: content,
      source_lang: from,
      target_lang: to,
      service: service,
      batchTranslations: batchTranslations,
      translateAnswers: translateAnswers,
    });

    // execute the request an returns a Promise<OPOTranslateResponse>
    return fetch(apiUrl, {
      body,
      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-type": "application/json",
        "X-API-KEY": apiKey,
      }),
    }).then(async (resp) => {
      if (!resp.ok)
        return Promise.reject(
          "A error occured with translation API. Check the service configuration.",
        );

      return resp
        .json()
        .then((data) =>
          Promise.resolve(
            data["translations"].map(
              (translation: IIndexable) => translation.text,
            ),
          ),
        );
    });
  };
};

export default { makeTranslationRequestBuilder };
